module.exports = __webpack_public_path__ + "img/2020-3min-en.7e255e87.jpg";